import React from 'react';
import {
  BaseConstruction,
  ConstructionPlan,
  PartialScopeValue,
  StyleConstruction,
  UntactConstruction,
  UntactConsult,
} from '@remodeling/remodeling-manager';

/**
 * 언택트 상담의 step
 * 기본공사
 * 공사계획
 * 기본공사
 * 스타일공사
 */
export type StepType = keyof UntactConsult;

/**
 * 공사계획 step
 * 공사범위
 * 공사희망일
 * 현재공간상태
 * 선호 스타일
 * 공사 그레이드
 * 스크랩 공유
 */
export type ConstructionPlanStepType = keyof Omit<
  ConstructionPlan,
  'firstScopes' | 'secondScopes'
>;

/**
 * 기본공사 step
 * 확장공사
 * 목공-천장몰딩
 * 목공-천장디자인
 * 목공-벽디자인
 * 타일공사
 * 필름공사
 * 도장-발코니
 * 도배공사
 * 기타공사
 */
export type BaseConstructionStepType =
  | keyof Omit<BaseConstruction, 'carpentryConstruction'>
  | `carpentryConstruction.${keyof BaseConstruction['carpentryConstruction']}`;

/**
 * 스타일공사 step
 * 창호공사
 * 도어공사
 * 중문공사
 * 욕실공사
 * 바닥공사
 * 부엌가구
 * 수납가구
 * 벽스타일
 * 조명공사
 * 남기고 싶은말
 */
export type StyleConstructionStepType =
  | keyof StyleConstruction
  | 'floorConstructions'
  | 'wallStyleConstructions';

export type AllSubStepType =
  | ConstructionPlanStepType
  | BaseConstructionStepType
  | StyleConstructionStepType;

export type SubStepItem = Omit<
  // eslint-disable-next-line no-use-before-define
  StepItem<AllSubStepType> & {
    /* 연관있는 부분공사 정보
    PARTIAL_RELATION_VISIBLE: 부분공사 and 전체공사 노출
    PARTIAL_RELATION_HIDDEN: 전체공사만 노출
  */
    relationPartialScope:
      | PartialScopeValue
      | 'PARTIAL_RELATION_VISIBLE'
      | 'PARTIAL_RELATION_HIDDEN';
    /**
     * 필수항목여부
     */
    required?: boolean;
    /**
     * 공사제외 체크항목 여부(모든항목 공사제외 일경우 체크를 위해)
     */
    checkExclude?: boolean;
  },
  'icon' | 'subSteps' | 'hiddenBySubStep'
>;

export type StepItem<T = StepType> = {
  seq: number;
  type: T;
  title: string;
  icon?: React.ReactNode;
  visit?: boolean;
  error?: boolean;
  // 현재 활성화된 스텝인지
  current?: boolean;
  // 서브 스텝이 없는경우 hidden해야 하는 스텝인지
  hiddenBySubStep?: boolean;

  subSteps: SubStepItem[];
  gtm?: {
    exitEvent?: string;
  };
};

export type NewUntactConstruction = UntactConstruction | null;

export type MarkedImageInfo = { url: string; isReverse?: boolean };

/**
 * 언택트 신청 진입경로
 * UNTACT_START: 언택트 시작하기
 * UNTACT_DETAIL: 언택트 상세
 */
export type UntactRequestEntryRoute = 'UNTACT_START' | 'UNTACT_DETAIL';

export type PUBLISH_FORM_DATA_EVENT_TYPE =
  | 'close'
  | 'checkDiffBeforeMoveStep'
  | 'initConstructionScope';
